import React from "react";

const TermsAndConditionsPage = () => {
  return (
    <div className="container px-lg-5 pt-5">
      {" "}
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="d-flex flex-column">
            <h1 className="font-face-PlusJakartaSans-Bold">
              Terms Of Services
            </h1>
          </div>

          <div className="text-black">
            <p className="">
              Welcome to Realty Base. These Terms and Conditions govern your use
              of our website and services. By accessing or using our platform,
              you agree to comply with these terms. If you do not agree, please
              refrain from using Realty Base.
            </p>
            <h5 className="mt-5">1. Introduction</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              Realty Base provides a digital platform for real estate listings,
              property management, and related services. The terms outlined here
              establish a legally binding agreement between you and Realty Base.
              By accessing our website, you acknowledge that you have read,
              understood, and agreed to these terms.
            </p>

            <h5>Your Use of Realty Base</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              To use Realty Base, you must be at least 18 years old and capable
              of forming a legally binding contract. Certain features require
              account registration, and you are responsible for maintaining the
              security of your credentials and ensuring your information is
              accurate. You agree not to post false, misleading, or fraudulent
              property listings, engage in unlawful activities such as copyright
              infringement or data scraping, attempt to interfere with platform
              security, or use the platform for spam or unsolicited messages.
              Realty Base reserves the right to terminate accounts that violate
              these conditions.
            </p>

            <h5>Content and Ideas</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              By submitting property listings, reviews, or other content, you
              grant Realty Base a non-exclusive, royalty-free, worldwide license
              to use, display, and distribute your content for promotional
              purposes. Realty Base does not guarantee the accuracy of property
              listings or third-party content, and users should verify details
              before making transactions. All trademarks, logos, and content on
              Realty Base are protected by copyright and intellectual property
              laws. You may not reproduce, distribute, or modify any part of our
              website without prior consent.
            </p>

            <h5>Limitation of Liability</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              Realty Base is not responsible for any damages resulting from your
              use of the platform, including financial loss, property disputes,
              or unauthorized access to your account. Your use of Realty Base is
              at your own risk.
            </p>

            <h5>Privacy Policy</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              We value your privacy. Our Privacy Policy outlines how we collect,
              use, and store your information. By using Realty Base, you consent
              to our data practices.
            </p>

            <h5>Changes to Terms</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              Realty Base reserves the right to update these Terms and
              Conditions at any time. Changes will be posted on this page, and
              your continued use of the platform constitutes acceptance of the
              revised terms.
            </p>

            <h5>Contact Information</h5>
            <p className="m-0 py-2 text-justify font-face-PlusJakartaSans-Regular">
              For questions regarding these terms, you can contact us at: Email:
              admin@realtybase.com. By using Realty Base, you acknowledge and
              agree to these Terms and Conditions. Thank you for being a part of
              our community!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
